import propertyLogo from "../../../assets-user/property.svg";
import beautifulFamilyImg from "../../../assets-user/beautifulFamily.png";

const PropertyBanner = () => {
  return (
    <div className="w-full px-4 sm:px-6 lg:px-10 py-10">
      <div className="mx-auto">
        <div className="relative bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl lg:rounded-3xl overflow-hidden shadow-lg">
          <div className="flex flex-col md:flex-row items-start justify-start">
            {/* Left Content Section */}
            <div className="w-full md:w-1/2 p-6 space-y-6">
              <h2 className="font-poppins font-semibold text-xl sm:text-2xl md:text-[28px] leading-[150%] tracking-[1%] text-[#2F2F2F] mt-4">
                Make Your Dreams Come True!
              </h2>
              <p className="font-poppins font-normal text-base sm:text-lg md:text-[20px] leading-[150%] tracking-[1%] text-[#7D7D7D] w-full xl:w-4/5">
                Connect with our experts to get personalized assistance for your
                property listing
              </p>
              {/* <button className="flex md:hidden items-center space-x-2 bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-xl transition-colors font-medium text-sm">
                <img src={propertyLogo} alt="" />
                <span>Post Property</span>
              </button> */}
              <button className="hidden lg:flex items-center space-x-2 bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-xl transition-colors font-medium text-sm">
                <img src={propertyLogo} alt="" />
                <span>Post Property</span>
              </button>
            </div>

            {/* Image Section */}
            <div className="hidden md:flex w-full md:w-1/2 relative">
              <img
                src={beautifulFamilyImg}
                alt=""
                className="w-full md:h-[230px] lg:h-[270px] xl:h-[250px]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyBanner;
